import { useState } from 'react';
import { Navbar, Container } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Drawer from './Drawer';

const AppNavbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [drawerOpen, setDrawerOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <>
      <Navbar className="app-navbar" fixed="top">
        <Container>
          <div className="d-flex align-items-center gap-3">
            {user && (
              <button
                className="hamburger-btn"
                onClick={() => setDrawerOpen(true)}
                aria-label="Open menu"
              >
                <span></span>
                <span></span>
                <span></span>
              </button>
            )}
            <Navbar.Brand as={Link} to="/">
              One<span className="accent">Circle</span>
            </Navbar.Brand>
          </div>

          <div className="ms-auto d-flex align-items-center gap-2">
            {user ? (
              <button className="btn-nav-logout" onClick={handleLogout}>
                Logout
              </button>
            ) : (
              <div className="d-flex align-items-center gap-3">
                <Link to="/login" className="nav-link-text">Login</Link>
                <Link to="/register" className="btn-nav-register">Register</Link>
              </div>
            )}
          </div>
        </Container>
      </Navbar>

      {user && (
        <Drawer show={drawerOpen} onHide={() => setDrawerOpen(false)} />
      )}
    </>
  );
};

export default AppNavbar;
